class BundleOptions extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.allBundleOptions = this.querySelectorAll(".bundle-option");
    this.bundleOptionGroups = this.querySelectorAll(".bundle-option-group");
    this.bundleVariants = JSON.parse(
      document.querySelector("[data-bundle-variants]")?.textContent || "[]"
    );
    this.productForm = document.getElementById(
      `ProductForm--${this.dataset.section}-${this.dataset.productId}`
    );
    this.addToCartButton = document.getElementById(`AddToCart--${this.dataset.section}`);
    this.selectedColor = new URLSearchParams(window.location.search).get("color");
    this.bundleType = this.dataset.bundleType;
    this.bundleDiscount = this.dataset.bundleDiscount || 0;
  }

  connectedCallback() {
    this.init();

    if (this.bundleOptionGroups.length > 1 || this.bundleType == "bundle") {
      this.selectVariants();
    } else {
      this.selectVariant(this.selectedColor);
    }
    this.updatePrice();
    this.validateSelections();
  }

  init() {
    this.addToCartButton = this.getAddToCartButton();
    this.productForm = this.getProductForm();
    
    if(this.bundleType == "bundle") {
      this.addToCartButton.addEventListener("click", (e) => this.addBundleToCart(e));
    }

    this.setupQuantityListener();
  }

  getAddToCartButton() {
    if (this.addToCartButton) return this.addToCartButton;

    let parent = this.parentElement;
    while (parent) {
      const button = parent.querySelector("button[data-add-to-cart]");
      if (button) {
        return button;
      }
      parent = parent.parentElement;
    }
    return null;
  }

  getProductForm() {
    if (this.productForm) return this.productForm;

    let parent = this.parentElement;
    while (parent) {
      const productForm = parent.querySelector("form[data-product-form]");
      if (productForm) {
        return productForm;
      }
      parent = parent.parentElement;
    }
    return null;
  }

  onVariantChange() {
    if (this.bundleOptionGroups.length > 1 || this.bundleType == "bundle") {
      this.selectVariants();
    } else {
      this.selectVariant();
    }
    this.updatePrice();
    this.validateSelections();
  }

  setupQuantityListener() {
    // Find the quantity counter element
    const quantityCounter = this.productForm?.querySelector("quantity-counter");
    if (quantityCounter) {
      // Listen for changes in the quantity input
      const quantityInput = quantityCounter.querySelector('input[name="quantity"]');
      if (quantityInput) {
        quantityInput.addEventListener("change", () => {
          this.onVariantChange();
        });
      }

      // Also listen for changes in the popout select if it exists
      const popoutSelect = quantityCounter.querySelector("popout-select");
      if (popoutSelect) {
        popoutSelect.addEventListener("change", () => {
          this.onVariantChange();
        });
      }

      // Listen for click events on quantity buttons
      const quantityButtons = quantityCounter.querySelectorAll(
        'button[name="increase"], button[name="decrease"]'
      );
      quantityButtons.forEach((button) => {
        button.addEventListener("click", () => {
          // Use setTimeout to ensure the quantity value has been updated
          setTimeout(() => {
            this.onVariantChange();
          }, 0);
        });
      });

      // Listen for popout option clicks
      const popoutOptions = quantityCounter.querySelectorAll("[data-popout-option]");
      popoutOptions.forEach((option) => {
        option.addEventListener("click", () => {
          // Use setTimeout to ensure the quantity value has been updated
          setTimeout(() => {
            this.onVariantChange();
          }, 0);
        });
      });
    }
  }

  addBundleToCart(e) {
    const mainProductJson = JSON.parse(
      document.querySelector("[data-product-json]")?.textContent || "{}"
    );
    const mainProductVariantId = mainProductJson.variants[0].id;
    e.preventDefault();

    const quantityInput = this.productForm?.querySelector('input[name="quantity"]');
    const currentQuantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    const componentItems = this.selectedVariants.map((variant) => ({
      id: variant.id.toString(),
      qty: variant.quantity,
      price: (variant.price / 100).toString(),
    }));

    let formData = {
      items: [
        {
          id: mainProductVariantId,
          quantity: currentQuantity,
          properties: {
            _components: JSON.stringify(componentItems),
          },
        },
      ],
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .catch((error) => console.log(error));
  }

  selectVariant(selectedColor = null) {
    const selectedColorContainer = this.bundleOptionGroups[0]?.querySelector(".selected-color");

    // Helper to handelize a string (Shopify style)
    function handelize(str) {
      return str
        .toLowerCase()
        .replace(/'/g, "")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    }

    // If selectedColor is provided, try to select the matching radio input
    if (selectedColor) {
      const selectedColorHandelized = handelize(selectedColor);
      const colorInputs = Array.from(
        this.bundleOptionGroups[0]?.querySelectorAll('input[type="radio"]')
      );
      let found = false;
      for (const input of colorInputs) {
        // Compare both the value and its handelized version
        if (handelize(input.value) === selectedColorHandelized || input.value === selectedColor) {
          input.checked = true;
          found = true;
          break;
        }
      }
      // If not found, fallback to first checked (default)
    }

    // Now get the selected options after possibly updating checked state
    const selectedOptions = Array.from(
      this.bundleOptionGroups[0]?.querySelectorAll('input[type="radio"]:checked')
    ).map((option) => option.value);

    const variant = this.bundleVariants.find(
      (variant) =>
        variant.group == 1 &&
        variant.options.every((option) =>
          selectedOptions.some(
            (selected) => selected === option || handelize(selected) === handelize(option)
          )
        )
    );

    if (!variant) return;

    const input = document.querySelector(
      `input[name='id'][form="${this.productForm.getAttribute("id")}"]`
    );
    if (input) {
      input.value = variant.id;
    } else {
      return alert("No input found");
    }

    this.price = variant.price;
    this.comparePrice = variant.compare_at_price;

    // Set selected color text (find the checked input with a swatch label)
    const checkedColorInput = this.bundleOptionGroups[0].querySelector(
      'input[type="radio"]:checked:has(+ .swatches)'
    );
    if (checkedColorInput) {
      selectedColorContainer.textContent = checkedColorInput.value;
    } else if (selectedOptions.length > 0) {
      selectedColorContainer.textContent = selectedOptions[0];
    } else {
      selectedColorContainer.textContent = "";
    }

    const image = variant.image;

    if (!image) return;

    const widths = [
      180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1950, 2100, 2260, 2450, 2700, 3000, 3350,
      3750, 4100, 4450, 4800, 5150, 5500, 5760,
    ];

    const srcset = widths
      .map((w) => {
        let url = variant.image;
        if (url.match(/_\d+x\./)) {
          url = url.replace(/_\d+x\./, `_${w}x.`);
        } else {
          url = url.replace(/(\.[a-zA-Z0-9]+)$/, `_${w}x$1`);
        }
        return `${url} ${w}w`;
      })
      .join(", ");

    if (!srcset) return;

    const imgEl = document.querySelectorAll(
      ".product__page .product__slides .product__media-wrapper .image-wrapper img"
    )?.[1];

    if (imgEl) {
      imgEl.src = image;
      imgEl.srcset = srcset;
    }
  }

  selectVariants() {
    console.log("Selecting variants");
    this.selectedVariants = [];
    for (let i = 0; i < this.bundleOptionGroups.length; i++) {
      const group = this.bundleOptionGroups[i];
      const selectedOption = group.querySelector(`select[name="bundle-variant-${i + 1}"]`).value;
      const variant = this.bundleVariants.find(
        (variant) => variant.group == i + 1 && variant.id == selectedOption
      );
      if (variant) {
        this.selectedVariants.push(variant);
      }
    }

    const originalPrice = this.selectedVariants.reduce((acc, variant) => {
      return acc + (variant.price * variant.quantity || 1);
    }, 0);

    // Apply bundle discount if present
    if (this.bundleDiscount && parseFloat(this.bundleDiscount) > 0) {
      this.comparePrice = originalPrice;
      this.price = originalPrice * (1 - parseFloat(this.bundleDiscount) / 100);
    } else {
      this.price = originalPrice;
      this.comparePrice = null;
    }

    // const bundleId = new Date().getTime();

    // // Remove any previous hidden inputs to avoid duplicates
    // const prevBundleIdInput = productForm.querySelector('input[name="properties[_bundleId]"]');
    // if (prevBundleIdInput) prevBundleIdInput.remove();
    // const prevBundleItemsInput = productForm.querySelector(
    //   'input[name="properties[_bundleItems]"]'
    // );
    // if (prevBundleItemsInput) prevBundleItemsInput.remove();
    // const prevBundlePriceInput = productForm.querySelector(
    //   'input[name="properties[_bundleDiscount]"]'
    // );
    // if (prevBundlePriceInput) prevBundlePriceInput.remove();

    // // Create and append hidden input for _bundleId
    // const bundleIdInput = document.createElement("input");
    // bundleIdInput.type = "hidden";
    // bundleIdInput.name = "properties[_bundleId]";
    // bundleIdInput.value = bundleId;
    // productForm.appendChild(bundleIdInput);

    // // Create and append hidden input for _bundleItems
    // const bundleItemsInput = document.createElement("input");
    // bundleItemsInput.type = "hidden";
    // bundleItemsInput.name = "properties[_bundleItems]";
    // bundleItemsInput.value = JSON.stringify(selectedVariants.map((variant) => variant.id));
    // productForm.appendChild(bundleItemsInput);

    // // Create and append hidden input for _bundleDiscount
    // const bundlePriceInput = document.createElement("input");
    // bundlePriceInput.type = "hidden";
    // bundlePriceInput.name = "properties[_bundleDiscount]";
    // bundlePriceInput.value = (this.price / selectedVariants.length / 100).toFixed(2);
    // productForm.appendChild(bundlePriceInput);
  }

  updatePrice() {
    const getPriceFormatted = (price) => { 
      // Use Shopify's money format from theme settings
      const moneyFormat =
        window.theme && window.theme.moneyFormat
          ? window.theme.moneyFormat
          : Shopify && Shopify.money_format
            ? Shopify.money_format
            : "{{ shop.money_format }}";
      
      let formattedPrice;
      if (window.theme.formatMoney) {
        formattedPrice = window.theme.formatMoney(price, moneyFormat);
      } else {
        // Fallback: Danish style
        formattedPrice = (price / 100).toLocaleString("da-DK", {
          style: "currency",
          currency: window.theme && window.theme.currency ? window.theme.currency : "DKK",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
      return formattedPrice;
    }

    // Find the price container and update the price display
    const priceWrapper = document.querySelector(".product__price__wrap [data-price-wrapper]");
    const priceWrap = document.querySelector(".product__price__wrap [data-product-price]");
    let comparePriceWrap = document.querySelector(".product__price__wrap [data-compare-price]");
    let compareTextWrap = document.querySelector(".product__price__wrap [data-compare-text]");
    const productSaleBadge = document.querySelector(".product__price__wrap [data-price-off-badge]");
    const priceOffAmount = document.querySelector(".product__price__wrap [data-price-off-amount]");
    const priceOffWrap = document.querySelector(".product__price__wrap [data-price-off]");

    if (priceWrap) {
      let formattedPrice = getPriceFormatted(this.price);
      priceWrap.textContent = formattedPrice;
      
      // Add sale class if there's a compare price
      if (this.comparePrice && this.comparePrice > this.price) {
        priceWrap.classList.add("product__price--sale");
      } else {
        priceWrap.classList.remove("product__price--sale");
      }
    }

    // Create compare price elements if they don't exist
    if (!compareTextWrap && priceWrapper) {
      compareTextWrap = document.createElement("span");
      compareTextWrap.className = "visually-hidden";
      compareTextWrap.setAttribute("data-compare-text", "");
      compareTextWrap.textContent = window.theme.strings.regularPrice || "Normal pris";
      priceWrapper.appendChild(compareTextWrap);
    }

    if (!comparePriceWrap && priceWrapper) {
      comparePriceWrap = document.createElement("s");
      comparePriceWrap.className = "product__price--strike";
      comparePriceWrap.setAttribute("data-compare-price", "");
      comparePriceWrap.style.display = "none";
      priceWrapper.appendChild(comparePriceWrap);
    }

    if (comparePriceWrap) {
      if (this.comparePrice && this.comparePrice > this.price) {
        comparePriceWrap.style.display = "inline";
        compareTextWrap.style.display = "inline";
        let formattedComparePrice = getPriceFormatted(this.comparePrice);
        comparePriceWrap.textContent = formattedComparePrice;

        // Calculate and display discount percentage
        const discountPercent = Math.round(((this.comparePrice - this.price) / this.comparePrice) * 100);
        
        // Show the price off wrapper
        if(priceOffWrap) {
          priceOffWrap.classList.remove("hidden");
        }
        
        if(productSaleBadge) {
          productSaleBadge.style.display = "inline";
          productSaleBadge.classList.remove("hidden");
        }
        
        if(priceOffAmount) {
          priceOffAmount.textContent = discountPercent + "%";
        }
      } else {
        comparePriceWrap.style.display = "none";
        if(compareTextWrap) {
          compareTextWrap.style.display = "none";
        }

        if(priceOffWrap) {
          priceOffWrap.classList.add("hidden");
        }

        if(productSaleBadge) {
          productSaleBadge.style.display = "none";
          productSaleBadge.classList.add("hidden");
        }
      }
    }
  }

  validateSelections() {
    //if not all bundle options are selected, disable the add to cart button
    if (
      Array.from(this.allBundleOptions).some(_ => _.querySelector("input")) && Array.from(this.allBundleOptions).some((option) => !option.querySelector("input:checked"))
    ) {
      this.addToCartButton.disabled = true;
      this.addToCartButton.textContent = window.theme.strings.bundleSelectAll;
      return;
    } else {
      this.addToCartButton.disabled = false;
      this.addToCartButton.textContent = window.theme.strings.addToCart;
    }

    if (this.selectedVariants) {
      const outOfStockVariants = this.selectedVariants.filter((variant) => !variant.available);

      //if any selected variant has an inventory_quantity of 0, disable the add to cart button
      if (outOfStockVariants.length > 0) {
        this.addToCartButton.disabled = true;
        this.addToCartButton.textContent = window.theme.strings.soldOut;
        return;
      } else {
        this.addToCartButton.disabled = false;
        this.addToCartButton.textContent = window.theme.strings.addToCart;
      }
    }
  }
}

if (!customElements.get("bundle-options")) {
  customElements.define("bundle-options", BundleOptions);
}
